import React from 'react';
import { Utensils, Flame, Users, Leaf, Heart } from 'lucide-react';

const checklist = [
  { icon: <Flame size={16} />, text: 'Fresh Daily' },
  { icon: <Utensils size={16} />, text: 'Charcoal Grilled' },
  { icon: <Users size={16} />, text: 'Family Owned' },
  { icon: <Leaf size={16} />, text: 'Locally Sourced' },
  { icon: <Heart size={16} />, text: 'No Artificial Flavors' },
];

const images = [
  { url: 'https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=400&q=80', alt: 'Grilled Chicken' },
  { url: 'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?w=400&q=80', alt: 'Kebabs' },
  { url: 'https://images.unsplash.com/photo-1580217593608-61931cefc821?w=400&q=80', alt: 'Fish & Chips' },
  { url: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&q=80', alt: 'Gourmet Burger' },
];

const AboutSection = () => (
  <section className="section-padding" style={{ backgroundColor: '#faf8f5' }}>
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-6 reveal-left">
          <span className="section-subtitle">Our Story</span>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600, marginBottom: '16px' }}>
            A Tradition of Culinary Excellence
          </h2>
          {/* Since 2018 badge */}
          <div style={{
            width: 80, height: 80, borderRadius: '50%', border: '3px solid #D4AF37',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            marginBottom: '20px', color: '#D4AF37'
          }}>
            <span style={{ fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600 }}>Since</span>
            <span style={{ fontSize: '1.3rem', fontWeight: 700, fontFamily: 'Playfair Display, serif' }}>2018</span>
          </div>
          {/* Pull quote */}
          <p style={{
            fontFamily: 'Playfair Display, serif', fontSize: '1.15rem', fontStyle: 'italic',
            color: '#2C2C2C', lineHeight: 1.8, borderLeft: '3px solid #D4AF37',
            paddingLeft: '20px', marginBottom: '24px'
          }}>
            "Every dish we cook carries the warmth of our family"
          </p>
          <p style={{ fontSize: '1rem', lineHeight: 2, color: '#666', marginBottom: '20px' }}>
            Syra Food Point & Grill stands as Seguku's premier dining destination, where passion for food meets exceptional hospitality. Our chefs craft each dish with the finest ingredients, bringing together traditional recipes with contemporary flair.
          </p>
          {/* Checklist */}
          <div className="d-flex flex-wrap gap-3 mb-4">
            {checklist.map((item, i) => (
              <div key={i} className="d-flex align-items-center gap-2" style={{ fontSize: '0.88rem', fontWeight: 500 }}>
                <span style={{ color: '#D4AF37' }}>{item.icon}</span>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="col-lg-6 reveal-right">
          <div className="row g-3">
            {images.map((img, i) => (
              <div key={i} className="col-6" style={{ marginTop: i % 2 === 1 ? '30px' : 0 }}>
                <div className="hover-lift" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                  <img src={img.url} alt={img.alt} style={{ height: '200px', objectFit: 'cover', width: '100%' }} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
